<template>
  <div class="__wrapper">
    <div class="__head"></div>
    <div class="__body">
      <div class="__container">
        <div class="__section-center">
          <div class="section-center__layout">
            <div class="layout__left">
              <div class="__card lesss">
                <div class="contact-card">
                  <div class="section">
                    <img :src="$fullUrl('images/profiles/'+user.profile)" />
                    <h2>{{user.names | validate }}</h2>
                    <span>{{user.job | validate }}</span>
                    <span>{{user.location | validate }}</span>
                  </div>
                  <div class="section">
                    <span>{{user.phone | validate }}</span>
                    <span>{{user.email | validate }}</span>
                  </div>
                  <div class="section">
                    <span>{{user.available | validate }}</span>
                    <span>{{user.available_from | validate }}</span>
                  </div>
                </div>
              </div>
              <div class="__suggestion-box">
                <div class="__body">
                  <div class="vertical">
                    <span>About Help Center</span>
                    <span>Privacy & Terms</span>
                    <span>Advertising</span>
                    <span>Business Services</span>
                    <img src="../assets/icons/log_dark.svg" />
                    <h1>Meritios</h1>
                    <label>Meritios © 2019</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="layout__right">
              <div class="__card lesss">
                <div class="description">
                  <h2>Description</h2>
                  <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut.</p>
                  <div class="action-links">
                    <router-link to="/profile/consultant">
                      <span>View full profile…</span>
                    </router-link>
                    <button>Message</button>
                  </div>
                </div>
              </div>
              <div class="__card lesss">
                <div class="__card-wrap">
                  <h2 class="title">Employment</h2>
                  <div
                    class="__row"
                    :class="{__last : i === employments.slice(0,2).length -1}"
                    v-for="(emp,i) in employments.slice(0,2)"
                  >
                    <div class="group">
                      <img src="../assets/icons/v__icon.svg" />
                      <div class="column">
                        <h3>{{emp.company.name | validate }}</h3>
                        <label>{{emp.role | validate }}</label>
                      </div>
                    </div>
                    <span class="date">{{emp.from | formatDate | validate }} up to {{emp.to | formatDate | validate }}</span>
                  </div>
                  <span class="right">More Companies</span>
                </div>
              </div>
              <div class="__card lesss">
                <div class="__card-wrap">
                  <h2 class="title">Projects</h2>
                  <div
                    class="__row"
                    :class="{__last : i === projects.slice(0,2).length -1}"
                    v-for="(proj,i) in projects.slice(0,2)"
                  >
                    <div class="group">
                      <img src="../assets/icons/v__icon.svg" />
                      <div class="column">
                        <h3>{{proj.name | validate }}</h3>
                        <label>{{proj.company.name | validate }}</label>
                      </div>
                    </div>
                    <span class="date">{{proj.from |formatDate  | validate }} to {{proj.to | formatDate | validate }}</span>
                  </div>
                  <span class="right">More Projects</span>
                </div>
              </div>
              <div class="__card lesss">
                <div class="__card-wrap">
                  <h2 class="title">Education</h2>
                  <div
                    class="__row"
                    :class="{__last : i === getMeProfile.educations.slice(0,2).length -1}"
                    v-for="(ed,i) in getMeProfile.educations.slice(0,2)"
                  >
                    <div class="group">
                      <img
                        :src="$fullUrl('images/educations/'+ed.logo)"
                        v-if="ed.logo"
                        class="circled-avatar"
                      />
                      <img src="../assets/icons/v__icon.svg" v-else />
                      <div class="column">
                        <h3>{{ed.organization | validate }}</h3>
                        <label>{{ed.degree | validate }}</label>
                      </div>
                    </div>
                    <span class="date">{{ed.from | formatDate  | validate }} to {{ed.to | formatDate | validate }}</span>
                    <!--<label class="date">{{ed.created_at | formatDate  | validate }}</label>-->
                  </div>
                  <span class="right">More Qualifications</span>
                </div>
              </div>
              <div class="__card lesss">
                <div class="__card-wrap">
                  <h2 class="title">Skills</h2>
                  <div class="skills">
                    <div class="boxes">
                      <div class="box">
                        <img src="../assets/icons/tools.svg" />
                        <span>Tools</span>
                      </div>
                      <div class="box">
                        <img src="../assets/icons/domains.svg" />
                        <span>Domains</span>
                      </div>
                      <div class="box">
                        <img src="../assets/icons/competence.svg" />
                        <span>Competence</span>
                      </div>
                      <div class="box">
                        <img src="../assets/icons/roles.svg" />
                        <span>Roles</span>
                      </div>
                      <div class="box">
                        <img src="../assets/icons/languages.svg" />
                        <span>Languages</span>
                      </div>
                    </div>
                    <div class="list">
                      <div class="item">
                        <div class="box-white" v-for="(item,index) in personalSkills.tools">
                          <span>{{item.name | validate }}</span>
                        </div>
                      </div>
                      <div class="item">
                        <div class="box-white" v-for="(item,index) in personalSkills.domains">
                          <span>{{item.name | validate }}</span>
                        </div>
                      </div>
                      <div class="item">
                        <div class="box-white" v-for="(item,index) in personalSkills.competences">
                          <span>{{item.name | validate }}</span>
                        </div>
                      </div>
                      <div class="item">
                        <div class="box-white" v-for="(item,index) in personalSkills.roles">
                          <span>{{item.name | validate }}</span>
                        </div>
                      </div>
                      <div class="item" v-for="(item,index) in personalSkills.languages">
                        <div class="box-white">
                          <span>{{item.lang.name | validate }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="right">More Qualifications</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="__section-right"></div>
      </div>
      <div class="floater">
        <chat></chat>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "../main";
import Chat from "../components/Chat/Chat";
export default {
  name: "ProfileDashboard",
  components: { Chat },
  computed: {
    ...mapGetters([
      "getMeProfile",
      "getSearchResults",
      "getFeedsPosts",
      "getLoader",
    ]),
    id() {
      return this.getMeProfile.user.id;
    },
    job() {
      let job = {};
      try {
        job = {
          company: this.getMeProfile.employment[0].company.name,
          role: this.getMeProfile.employment[0].skills[0].roles[0].name,
          from: this.getMeProfile.employment[0].from,
          description: this.getMeProfile.employment[0].description,
        };
        return job;
      } catch (err) {
        return job;
      }
    },
    skills() {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      this.getMeProfile.skills.forEach((skill) => {
        skills.tools = skills.tools.concat(skill.tools);
        skills.domains = skills.domains.concat(skill.domains);
        skills.languages = skills.languages.concat(skill.languages);
        skills.competences = skills.competences.concat(skill.competences);
        skills.roles = skills.roles.concat(skill.roles);
      });
      return skills;
    },
    location() {
      if (this.getMeProfile.profile.location_id === null) return "";
      else
        return (
          this.getMeProfile.profile.location.country.name +
          "," +
          this.getMeProfile.profile.location.city.name +
          "," +
          this.getMeProfile.profile.location.address
        );
    },
    user() {
      let job = "not set";
      let country = "not set";
      let city = "not set";
      if (this.getMeProfile.employment.length > 0)
        job = this.getMeProfile.employment[0].company.name;
      if (this.getMeProfile.profile.location) {
        if (this.getMeProfile.profile.location.country_id)
          country = this.getMeProfile.profile.location.country.name;
        if (this.getMeProfile.profile.location.city_id)
          city = this.getMeProfile.profile.location.city.name;
      }
      return {
        profile: this.getMeProfile.user.profile_picture,
        names:
          this.getMeProfile.user.first_name +
          " " +
          this.getMeProfile.user.last_name,
        email: this.getMeProfile.user.email,
        phone: this.getMeProfile.profile.phone,
        city: city,
        country: country,
        job: job,
      };
    },
    projects() {
      let location = { country: {}, city: {}, address: "" };
      return this.getMeProfile.projects.map(function (item) {
        if (!item.company) eventBus.$set(item, "company", "");

        if (!item.location) {
          eventBus.$set(item, "loc", "");
          eventBus.$set(item, "location", {
            country: {},
            city: {},
            address: "",
            id: 0,
          });
        } else eventBus.$set(item, "loc", item.location.country.name + "," + item.location.city.name + "  " + item.location.address);

        eventBus.$set(item, "collapse", true);
        return item;
      });
    },
    employments() {
      let location = { country: {}, city: {}, address: "", id: 0 };
      return this.getMeProfile.employment.map(function (item) {
        if (!item.company) eventBus.$set(item, "no company", "");

        if (!item.location) {
          eventBus.$set(item, "loc", "");
          eventBus.$set(item, "location", {
            country: {},
            city: {},
            address: "",
            id: 0,
          });
        } else eventBus.$set(item, "loc", item.location.country.name + "," + item.location.city.name + "  " + item.location.address);

        eventBus.$set(item, "collapse", true);
        let role = "no title";
        item.skills.forEach((skill) => {
          skill.roles.forEach((item) => {
            role = item.name;
          });
        });

        eventBus.$set(item, "role", role);

        return item;
      });
    },
    personalSkills() {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      this.getMeProfile.skills.forEach((skill) => {
        skills.tools = skills.tools.concat(skill.tools);
        skills.roles = skills.roles.concat(skill.roles);
        skills.domains = skills.domains.concat(skill.domains);
        skills.languages = skills.languages.concat(skill.languages);
        skills.competences = skills.competences.concat(skill.competences);
      });
      return skills;
    },
  },
  methods: {
    editProfile() {
      this.$router.push({ name: "profile-edit", params: { id: this.id } });
    },
  },
  mounted() {
    this.$store.dispatch("GET_ME_PROFILE_DATA");
  },
};
</script>

<style lang="scss" scoped>
.__wrapper {
  background: #efefef;
  min-height: 95.5%;
  .__head {
    height: 90px;
    margin-top: 30px;
    background: url("../assets/images/backgrounds/header_bg.svg");
    @media (min-width: 300px) and (max-width: 630px) {
      display: none;
    }
  }
  .__body {
    .__container {
      margin: 0 auto;
      width: 70%;
      display: grid;
      padding-top: 5px;
      grid-template-columns: 5fr 1fr;
      grid-column-gap: 10px;
      @media (min-width: 300px) and (max-width: 630px) {
        grid-template-columns: 1fr;
        width: 90%;
      }
      .__section-center {
        .section-center__layout {
          display: grid;
          grid-column-gap: 10px;
          grid-template-columns: 1fr 2.5fr;
          .layout__left {
            .contact-card {
              display: flex;
              flex-direction: column;
              .section {
                width: 100%;
                display: flex;
                padding: 20px 0;
                justify-content: center;
                align-items: center;
                border-bottom: 2px solid #f5f5f5;
                flex-direction: column;
                img {
                  width: 80px;
                  height: 80px;
                  margin-top: -40px;
                  border-radius: 100%;
                }
                h2 {
                  font-weight: normal;
                  color: #000000;
                  margin-top: 5px !important;
                  font-size: 16px;
                }
                span {
                  color: #4e4e4e;
                  font-size: 14px;
                }
              }
            }
            .__suggestion-box {
              padding: 10px;
              .__body {
                margin-top: 0px;
                background: transparent;
                .vertical {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;
                  span {
                    color: #999999;
                    font-size: 12px;
                    margin-bottom: 10px;
                    font-weight: normal;
                  }
                  h1 {
                    color: #959595;
                    font-size: 19px;
                    opacity: 0.6;
                    font-weight: normal;
                  }
                  label {
                    font-size: 11px;
                    font-weight: lighter;
                    margin-top: 30px;
                    color: #959595;
                  }
                  img {
                    margin-top: 30px;
                  }
                }
              }
            }
          }
          .layout__right {
            .__card-wrap {
              padding: 20px;
              display: flex;
              flex-direction: column;
              h2 {
                color: #3c4253;
                margin-bottom: 20px;
                font-size: 17px !important;
                font-weight: normal;
              }
              .__row {
                display: flex;
                width: 100%;
                justify-content: space-between;
                padding-bottom: 10px;
                padding-top: 10px;
                border-bottom: 0.9px solid #a0a0a0;
                .date {
                  color: #6e6e6e;
                  font-size: 13px;

                  font-weight: normal;
                }
                .group {
                  display: flex;
                  img {
                    width: 30px;
                    margin-top: -15px;
                  }
                  .column {
                    display: flex;
                    flex-direction: column;
                    margin-left: 10px;
                    h3 {
                      font-size: 14px;
                      color: #031019;
                      font-weight: normal;
                      margin-bottom: 0;
                    }
                    label {
                      font-size: 13px;
                      color: #646262;
                      margin: 0;
                      font-weight: lighter;
                    }
                    span {
                      color: #6e6e6e;
                      margin: 0;
                      font-size: 12px;
                    }
                  }
                }
              }
              .__last {
                border-bottom: none;
              }
              .right {
                align-self: flex-end;
                font-size: 14px;
                color: #808080;
                cursor: pointer;
                font-weight: lighter;
                &:hover {
                  text-decoration: underline;
                }
              }
              .skills {
                .boxes,
                .list {
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 20px;
                  .item {
                    display: flex;
                    flex-direction: column;
                  }
                  .box,
                  .box-white {
                    width: 90px;
                    min-height: 45px;
                    text-align: center;
                    border-radius: 5px;
                    display: flex;
                    background: #0081b5;
                    color: #fff;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                  }
                  .box-white {
                    background: transparent;
                    color: #646262;
                    border: 0.5px solid #707070;
                    margin-bottom: 10px;
                  }
                }
              }
            }
            .description {
              display: flex;
              padding: 20px 20px 10px 20px;
              flex-direction: column;
              h2 {
                color: #000000;
                font-size: 13px;
                font-weight: normal;
              }
              p {
                color: #6e6e6e;
                font-size: 15px;
              }
              .action-links {
                display: flex;
                justify-content: space-between;
                a {
                  color: #1885ad;
                  font-size: 13px;
                  text-decoration: none;
                }
                button {
                  outline: none;
                  border: none;
                  font-size: 13px;
                  font-weight: bold;
                  border-radius: 5px;
                  padding: 5px 7%;
                  color: #fff;
                  background: #1885ad;
                }
              }
            }
          }
        }
      }
      .__section-right {
        position: relative;
        @media (min-width: 300px) and (max-width: 630px) {
          top: 20px;
        }
        display: flex;
        flex-direction: column;
        h2 {
          font-size: 15px;
          color: #535353;
        }
        .__feed-box {
          padding: 10px;
          margin-top: 10px;
          background: #ffffff;
          box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);
          border-radius: 5px;
          .__title {
            padding: 10px 10px 0 10px;
            color: #808080;
            font-size: 20px;
            border-bottom: 0.7px solid rgba(112, 112, 112, 0.4);
          }
          .__body {
            margin-top: 20px;
            background: transparent;
            .__item {
              display: flex;
              margin-bottom: 20px;
              flex-direction: column;
              .__title,
              .__contents {
                display: flex;
                justify-content: space-around;
                border: none;
                flex-direction: row;
                .__green {
                  font-size: 12px;
                  cursor: pointer;
                }
                span {
                  font-size: 12px;
                }
                img {
                  margin-right: 10px;
                  width: 40px;
                  height: 40px;
                }
              }
            }
          }
        }
        .__chat {
          padding: 0 10px 10px 10px;
          height: 40px;
          background: #fafafa;
          box-shadow: 0 3px 4px rgba(0, 0, 0, 0.16);
          border: 0.5px solid rgba(112, 112, 112, 0.4);
          border-top-left-radius: 13px;
          border-top-right-radius: 13px;
          position: fixed;
          bottom: 0;
          .__title {
            padding: 10px;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            color: #00a99d;
            border: none;
          }
          .__input {
            margin-top: 10px;
            width: 220px;
            margin-bottom: 20px;
            input {
              background: url("../assets/icons/search.svg") right;
              background-size: 15px;
              outline: none;
              padding: 3px 5px 3px 10px;
              width: 100%;
              color: #999999;
              border: 0.7px solid rgba(112, 112, 112, 0.4);
              background-repeat: no-repeat;
              background-origin: content-box;
              &::placeholder {
                color: #999999;
              }
              &::-webkit-input-placeholder {
                /* Chrome/Opera/Safari */
                color: #999999;
              }
              &::-moz-placeholder {
                /* Firefox 19+ */
                color: #999999;
              }
              &:-ms-input-placeholder {
                /* IE 10+ */
                color: #999999;
              }
              &:-moz-placeholder {
                /* Firefox 18- */
                color: #999999;
              }
            }
          }
          .__body {
            background: transparent;
            height: 190px;
            cursor: pointer;
            overflow-y: auto !important;
            &::-webkit-scrollbar {
              background-color: transparent;
              width: 12px;
            }

            &::-webkit-scrollbar-track {
              background-color: transparent;
            }

            /* scrollbar itself */
            &::-webkit-scrollbar-thumb {
              background-color: #babac0;
              border-radius: 16px;
              border: 4px solid #f2f2f2;
            }
            &::-webkit-scrollbar-button {
              display: none;
            }
            .__item-chat {
              display: flex;
              background: transparent;
              flex-direction: row;
              cursor: pointer;
              padding: 10px 0;
              border-bottom: 0.7px solid rgba(112, 112, 112, 0.4);
              img {
                width: 35px;
                border-radius: 100px;
                height: 35px;
              }
              .__text {
                display: flex;
                text-align: left;
                flex-direction: column;
                margin-left: 10px;
                .__tite {
                  text-align: left;
                  font-size: 14px;
                  font-weight: lighter;
                  color: #666666;
                }
                ._2 {
                  color: #999999;
                  font-weight: lighter;
                  font-size: 11px;
                  margin-top: -5px;
                }
              }
            }
          }
        }
        .__chat-list {
          position: fixed;
          bottom: 0;
          right: 28%;
          display: flex;
          flex-direction: row-reverse;
          .__chat-individual {
            margin-right: 10px;
            height: 300px;
            background: #fafafa;
            box-shadow: 0 3px 4px rgba(0, 0, 0, 0.16);
            border: 0.5px solid rgba(112, 112, 112, 0.4);
            border-top-left-radius: 13px;
            border-top-right-radius: 13px;
            .__title {
              padding: 10px;
              cursor: pointer;
              width: 220px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              color: #00a99d;
              border: none;
              .__chat-header {
                img {
                  border-radius: 100px;
                  width: 15px;
                  margin-right: 5px;
                  height: 15px;
                }
              }
              img {
                width: 20px;
                height: 20px;
              }
            }
            .__body {
              background: #e6e6e6;
              height: 190px;
              padding-left: 10px;
              cursor: pointer;
              overflow-y: auto !important;
              &::-webkit-scrollbar {
                background-color: transparent;
                width: 12px;
              }

              &::-webkit-scrollbar-track {
                background-color: transparent;
              }

              /* scrollbar itself */
              &::-webkit-scrollbar-thumb {
                background-color: #babac0;
                border-radius: 16px;
                border: 4px solid #f2f2f2;
              }
              &::-webkit-scrollbar-button {
                display: none;
              }
              .__item-chat {
                display: flex;
                background: transparent;
                flex-direction: column;
                cursor: pointer;
                padding: 10px 0;
                img {
                  width: 35px;
                  border-radius: 100px;
                  height: 35px;
                }
                .__text {
                  display: flex;
                  text-align: left;
                  background: url("../assets/images/backgrounds/chat_bg-left.svg")
                    no-repeat;
                  background-size: contain;
                  padding: 5px 10px;
                  flex-direction: column;
                  margin-left: 10px;
                  span {
                    text-align: left;
                    font-size: 12px;
                    font-weight: lighter;
                    color: #ffffff;
                  }
                }
                .__me {
                  align-self: flex-end;
                  background: url("../assets/images/backgrounds/chat__bg-right.svg")
                    no-repeat;
                  span {
                    color: #00a99d;
                  }
                }
              }
            }
            .chat_typing-input {
              position: fixed;
              bottom: 0;
              width: 220px;
              padding: 0 5px;
              height: 65px;
              background: #fafafa;
              .__input-container {
                display: flex;
                justify-content: space-between;
                textarea {
                  font-size: 12px;
                  opacity: 0.8;
                  width: 80%;
                  outline: none;
                  font-weight: lighter;
                  &:hover {
                    outline: none;
                  }
                }
                img {
                  cursor: pointer;
                  width: 20px;
                  height: 20px;
                }
              }
              .__actions {
                display: flex;
                position: absolute;
                width: 100px;
                justify-content: space-between;
                bottom: 10px;
                flex-direction: row;
                .btn-post {
                  background: #1885ad;
                  padding-left: 20px;
                  color: #ffffff;
                  font-size: 12px;
                  font-weight: lighter;
                  padding-right: 20px;
                  padding-top: 2px;
                  border-radius: 2px;
                  cursor: pointer;
                }
                .__icon {
                  width: 20px;
                  height: 20px;
                  img {
                    width: 15px;
                    cursor: pointer;
                    height: 15px;
                  }
                }
              }
            }
          }
        }
        .__collapse {
          height: 300px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          padding: 10px;
        }
      }
    }
    .floater {
      position: fixed;
      bottom: 0px;
      right: 40px;
    }
    .__menus {
      display: none;
      @media (min-width: 300px) and (max-width: 630px) {
        display: grid;
        width: 100%;
        background: #f5f9fc !important;
        position: fixed;
        bottom: 0;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 1px;
      }
      span {
        padding: 10px;
        text-align: center;
        color: #1885ad;
      }
      .__activee {
        background: #1885ad;
        color: #fff;
      }
    }
  }
}
.__colored {
  color: #1890a9;
}
.__green {
  color: #1ba5a4;
}
.__white {
  color: #ffffff;
}
.__v-space {
  margin-top: 15px !important;
}
.error {
  border: 1px solid maroon !important;
}
.__card {
  background: #fff;
  padding: 20px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);
}
.less {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 20px;
  overflow: hidden;
}
.lesss {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 20px;
}
.greyed {
  background: #f8f8f8;
}
</style>